/* eslint-disable react/jsx-props-no-spreading */
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import { Box, Button, Collapse, Paper, Typography } from '@mui/material';
import React, { useState } from 'react';

import Checkbox from '../forms/Checkbox';
import DuplicateLineItemFields, { DuplicateLineItemFieldsProps } from './DuplicateLineItemFields';

function DuplicateLineItemsContainer(props: DuplicateLineItemFieldsProps) {
  const { lineItem, fieldNamePrefix } = props;
  const [open, setOpen] = useState(false);
  return (
    <Paper sx={{ width: '100%' }}>
      <Box sx={{ padding: 1 }}>
        <Button variant="text" size="large" color="inherit" fullWidth onClick={() => setOpen(!open)}>
          <Checkbox name={`${fieldNamePrefix}.copy`} label="" onClick={(e) => e.stopPropagation()} />
          <Typography sx={{ marginRight: 'auto' }}>{lineItem.lineItemName}</Typography>
          {open ? <ExpandLess /> : <ExpandMore />}
        </Button>
        <Collapse in={open} timeout="auto" unmountOnExit={false} sx={{ marginTop: 1 }}>
          <DuplicateLineItemFields {...props} />
        </Collapse>
      </Box>
    </Paper>
  );
}

export default DuplicateLineItemsContainer;
